import gql from "graphql-tag";

export default gql`mutation CreateVat($test:Boolean!, $testScenario:String, $vrn:Int!, $action:String!, $payload:JSON!, $clientHeaders:JSON!) {
    createVat(test:$test, testScenario:$testScenario, vrn:$vrn, action:$action, payload:$payload, clientHeaders:$clientHeaders) {
      id
      payload
      response
      status
      userid
      timestamp
      user {
        id
        name
      }
    }
  }`